import { message } from "antd";
import { authHeader } from "../../../helpers/auth-header";
import { client } from "../../../actions";
import uri from "../constants/uri";

const getStreets = async (fileId) => {
	try {
		const response = await client.get(`${uri}/street`, {
			headers: authHeader(),
			params: { fileId },
		});
		return response.data;
	} catch (error) {
		console.error(error);
		message.error("Не удалось загрузить адреса");
	}
};

export default getStreets;
